import { post } from "@/utils/utils";

const stock = {
  state: {},
  mutations: {
    QUERY_HEAT_MAP_DATA() {},
    QUERY_HEAT_MAP_STORE_LIST() {}
  },
  actions: {
    queryHeatMapData({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/address/member/heatmap`,
        name: "QUERY_HEAT_MAP_DATA",
        params
      });
    },
    queryHeatMapStoreList({ commit }, params) {
      return post({
        commit,
        url: `/basic/report/address/shop/heatmap`,
        name: "QUERY_HEAT_MAP_STORE_LIST",
        params
      });
    }
  }
};

export default stock;
